import Form from 'react-bootstrap/Form';

function SelectOptions() {
  return (
    <Form.Select aria-label="Default select example">
      <option>Choose an Option</option>
      <option value="1">Bank1</option>
      <option value="2">Bank2</option>
      <option value="2">Bank3</option>
      <option value="2">Bank4</option>
      <option value="2">Bank5</option>
      <option value="2">Bank6</option>
      <option value="2">Bank7</option>
      <option value="2">Bank8</option>
      <option value="2">Bank9</option>
    </Form.Select>
  );
}

export default SelectOptions;